<template>
  <div class="c-item-block">
    <span v-if="closable" class="m-closed" @click="$emit('close')"></span>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'smartItem',
  props: {
    closable: {
      type: Boolean
    }
  }
}
</script>
<style lang="scss" scoped>
.c-item-block {
  position: relative;
  display: inline-block;
  vertical-align: top;
  padding: 12px 0 0;
  margin: 0 12px 12px 0;

  .m-closed {
    position: absolute;
    color: #fff;
    width: 15px;
    height: 15px;
    line-height: 15px;
    font-size: 60%;
    border-radius: 9px;
    background-color: #ff635c;
    text-align: center;
    display: block;
    z-index: 11;
    top: 6px;
    right: -6px;
    transition: display 0.2s ease-in-out;
    cursor: pointer;

    &:after {
      content: 'x';
      transform: scale(0.7);
    }
  }

  .ivu-icon {
    position: absolute;
    left: 0;
    top: -8px;
    z-index: 3;
    cursor: pointer;
  }
}
</style>
